'use es6';

import { withRouter } from 'react-router-dom';
import LessonNavigatorContainer from './LessonNavigator/ExpandedLessonNavigatorLessonContainer';
import TrackNavigatorContainer from './TrackNavigator/TrackNavigatorContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const SmartNavigator = ({
  match: {
    params: {
      trackId
    } = {}
  }
}) => trackId ? /*#__PURE__*/_jsx(TrackNavigatorContainer, {}) : /*#__PURE__*/_jsx(LessonNavigatorContainer, {});
export default withRouter(SmartNavigator);